import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { Col } from "reactstrap";

export interface ButtonComponentProps {
    text: string;
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
    style?: React.CSSProperties | undefined;
    className?: string;
    icon?: JSX.Element;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    marginCol?: React.CSSProperties | undefined;
}

export default function ButtonComponent({
    onClick,
    text,
    loading,
    style,
    disabled,
    className,
    icon,
    xs,
    sm,
    md,
    lg,
    xl,
    marginCol
}: ButtonComponentProps) {
    const isDisabled = (): boolean => {
        if (typeof disabled !== "undefined" && disabled === true) return true;
        if (typeof loading !== "undefined" && loading === true) return true;
        return false;
    };

    return (
        <>
            {xl == null && lg == null && md == null && sm == null && xs == null ? (
                <>
                    <button
                        style={{ ...style, display: "flex", justifyContent: "center" }}
                        className={`button ${className}`}
                        onClick={() => onClick()}
                        disabled={isDisabled()}
                    >
                        {text} {icon}
                        {loading === true && (
                            <CircularProgress style={{ marginLeft: "0.5rem" }} size={"1.5em"} />
                        )}
                    </button>
                </>
            ) : (
                <>
                    <Col
                        xl={xl}
                        lg={lg}
                        md={md}
                        sm={sm}
                        xs={xs}
                    >
                        {marginCol !== undefined && 
                        <div style={{...marginCol}}>
                        </div>}
                        
                        <button
                            style={{ ...style, display: "flex", justifyContent: "center" }}
                            className={`button ${className}`}
                            onClick={() => onClick()}
                            disabled={isDisabled()}
                        >
                            {text} {icon}
                            {loading === true && (
                                <CircularProgress style={{ marginLeft: "0.5rem" }} size={"1.5em"} />
                            )}
                        </button>
                    </Col>
                </>
            )}
        </>
    );
}
